import React, { useContext, useEffect, useState } from "react";
import Wrapper from "../../../components/common/Wrapper/Wrapper";
import { HeaderHeading } from '../../../Context'
import organisms from "../../../components/organisms";
import { Default_Page_Limit } from "../../../constants/defaultValues"
import service from "../../../api/services";
import { useToasts } from "react-toast-notifications";
import { useNavigate } from "react-router";

const { Staff } = organisms
const Index = () => {
    const [initialLoading, setInitialLoading] = useState(false)
    const [staffData, setStaffData] = useState<any>([])
    const [currentPage, setCurrentPage] = useState(1);
    const [limitPerPage, setLimitPerPage] = useState(Default_Page_Limit);
    const [search, setSearch] = useState('');
    const { setHeader }: any = useContext(HeaderHeading);
    const navigate = useNavigate();
    const { addToast } = useToasts();

    useEffect(() => {
        setHeader("Staff List")
        if (initialLoading) {
            getStaffData()
        }
        setInitialLoading(true)
    }, [currentPage, search])

    useEffect(() => {
        setCurrentPage(1)
        if (currentPage == 1) {
            getStaffData()
        }
    }, [limitPerPage])


    const getStaffData = async () => {
        try {
            let response = await service.staff.view({ "page": currentPage, "search": search, "limit": limitPerPage })
            if (response.status === 200) {
                setStaffData(response.data)
            }
        } catch (error: any) {
            console.error(error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    const _handleDelete = async (id: string) => {
        try {
            const response = await service.staff.delete(id)
            if (response.status == 200) {
                getStaffData()
                addToast(response.data.message, {
                    appearance: 'success',
                    autoDismiss: true,
                    autoDismissTimeout: 3000,
                });
            }
        } catch (error: any) {
            console.error(error)
            addToast(error.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    }

    // INFO:-function to handle button hit of add subadmin
    const handleAddStaff = () => {
        // Get the current number of sub-admins and the allowed maximum
        const subAdmins = staffData?.data?.length || 0;
        const maxAllowed = staffData?.maxStaff || 0;

        //CRIT:- Navigate to the add-sub-admin page if under the limit, otherwise show an error toast
        subAdmins < maxAllowed
            ? navigate("/staff/add")
            : addToast("Maximum number of staff has been reached", {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
    };
    // end

    return (
        <Wrapper>
            <Staff
                setLimitPerPage={setLimitPerPage}
                setCurrentPage={setCurrentPage}
                _handleDelete={(id: string) => _handleDelete(id)}
                setSearch={setSearch}
                staffData={staffData}
                currentPage={currentPage}
                limitPerPage={limitPerPage}
                handleAddStaff={handleAddStaff}
            />
        </Wrapper>
    )

}

export default Index